import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldHasValue',
  standalone: true
})
export class FieldHasValuePipe implements PipeTransform {
  transform(value: string | string[]): boolean {
    return (Array.isArray(value) && value.length > 0) || typeof value === 'string';
  }
}
